export default "__VITE_ASSET__J7xCQmQ6__"